/**
 * ISO/IEC 7812 check digit (mod-10 / Luhn). Used as a client-side PAN
 * typo filter — not a proof the card exists.
 */
export const passesLuhn = (digits: string): boolean => {
  if (!/^\d{13,19}$/.test(digits)) return false;

  let sum = 0;
  let double = false;
  for (let i = digits.length - 1; i >= 0; i--) {
    let n = digits.charCodeAt(i) - 48;
    if (double) {
      n *= 2;
      if (n > 9) n -= 9;
    }
    sum += n;
    double = !double;
  }
  return sum % 10 === 0;
};
